var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-overlay',{attrs:{"show":_vm.show}},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"block"},[_c('van-loading',{attrs:{"color":"#2e73b4","size":"120"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }